














import { defineComponent, computed } from '@vue/composition-api';
import SwitchContainer from '@/components/common/switch-container/index.vue';

const name = 'ttam-placement-tiktok-only-switch';

export default defineComponent({
  name,
  components: {
    SwitchContainer,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      defalut: false,
    },
  },
  setup(props, { emit }) {
    const _tiktokOnlyStatus = computed({
      get: () => props.value,
      set: val => {
        emit('change', val);
        emit('input', val);
      },
    });

    return {
      _tiktokOnlyStatus,
    };
  },
});
